import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import { estilosTextosPrincipales, colores, backgroundRectangle, buttonPrimaryBig, buttonSecundaryBig } from '../../../AppStyle';

export const style = makeStyles({
    classGridContenedor: {
        ...backgroundRectangle
    },
    classGridCabecera: {
        height: 'fit-content',
        margin: 'auto',
        width: '90%',
        alignItems: 'end',
        marginTop: '24px'
    },
    classGridBuscador: {
        margin: '0 0 0 auto'
    },
    classGridBuscadorResponsive: {
        width: '100%',
        marginLeft: '5%',
        marginRight: '5%',
    },
    classInput: {//Estilo buscador

    },
    classGridSelect: {
        margin: '19px auto auto 32px'
    },
    classH2: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
    },
    classPopupTitle: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
        margin: '32px 32px 32px 32px'
    },
    classButton: {
        ...buttonPrimaryBig,
        margin: '48px 20px 50px auto',
        display: 'block'
    },
    classButtonResponsive: {
        width: '100%',
        marginLeft: '4%',
        ...buttonPrimaryBig,
        margin: '15px 14px 13px auto',
        display: 'block'
    },
    classButtonFilterResponsive: {
        ...buttonSecundaryBig,
        width: '100%',
        
        marginRight: '4%',
    },
    classBorrame: {
        marginTop: '10px',
    },
    classTable: {
        backgroundColor: '',
        width: '100%',
        height: '300px',
        margin: 'auto 32px 0px 32px'
    },
    classPager: {
        marginRight: '28px',
        marginBlock: '1%',
    },
    ///////////////////////////////BACKDROP
    classBackdrop: {
        zIndex: 1,
        color: '#fff',
    },
    //Estilos aplicados a los selectores
    classGrid: {
        textAlign: 'left',
        marginTop: '15px',
        marginBottom: '19px',
        marginRight: '32px',
        width: 'auto',
        display: 'block',
    },
    classInputLabel: {
        ...estilosTextosPrincipales.body2,
        color: colores.escalaGrises.ochenta,
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: ' 17px',
        marginBottom: '5px',
        position: 'relative',
        '&.Mui-focused': {
            color: '#555555',
        },
    },
    classSpanRequired: {
        color: colores.principales.required,
        ...estilosTextosPrincipales.body2,
    },
    searchButton: {
        borderBottomRightRadius: '5px', /**Que tenga la esquina curvo */
        borderTopRightRadius: '5px',
        height: '48px',
        width: '48px',
        '&.Mui-focusVisible': {
            boxShadow: '#087021 0 0 10px',
        },
        '&:hover': {
            boxShadow: '#087021 0 0 10px',

        }
    },
    searchImg: {
        height: '48px',
        width: '48px',
        borderBottomRightRadius: '5px', /**Que tenga la esquina curvo */
        borderTopRightRadius: '5px'
    },
    searchButtonPhone: {
        borderRadius: '0', /**Que sea un cuadrado */
        height: '40px',
        width: '40px',
        borderBottomRightRadius: '5px', /**Que tenga la esquina curvo */
        borderTopRightRadius: '5px',
        '&$focused': {
            boxShadow: '#087021 0 0 10px',
        },
    },
    searchImgPhone: {
        //height: '40px',
        //width: '40px',
        marginTop: '40% !important',
        borderBottomRightRadius: '5px', /**Que tenga la esquina curvo */
        borderTopRightRadius: '5px'
    },
    classSelectResponsive: {
        marginLeft: "5%",
        width: '100%',
    }

});

export const objStyle = {
    classGridPager: {
        direction: "row",
        justify: "flex-end",
        alignItems: "center"
    }
}


const obtenerTamanoBuscadorPhoneVersion = () => {
    const tamanoPagina = window.screen.width;
    const tamanoLupa = 48;
    const margen = 10;
    let resultado = '';
    resultado = `${tamanoPagina - ((tamanoPagina * margen) / 100) - tamanoLupa}px`;
    return resultado;
}

export default function customizate(condition) {
    const overInputs = createMuiTheme({
        overrides: {
            MuiInputBase: {//Clases aplicadas en los inputs
                root: {
                    height: '48px',
                    ...(condition) ? { width: obtenerTamanoBuscadorPhoneVersion } : { width: '280px' }
                },
                input: {
                    ...estilosTextosPrincipales.body2,
                    fontSize: '14px',
                    //lineHeight: '24px',
                    letterSpacing: '0px',
                    color: colores.escalaGrises.cien,
                    '&::placeholder': {
                        ...estilosTextosPrincipales.body2,
                        fontSize: '14px',
                        //lineHeight: '24px',
                        letterSpacing: '0px',
                        opacity: '0.8',
                        color: colores.escalaGrises.apoyo,
                    },
                },
            },
            MuiOutlinedInput: {//Clases aplicadas a los bordes de los inputs
                root: {
                    '&:hover $notchedOutline': {
                        border: '2px',
                        borderStyle: 'solid',
                        borderColor: colores.principales.principal
                    },
                    '&$focused $notchedOutline': {
                        border: '2px',
                        borderStyle: 'solid',
                        borderColor: colores.principales.principal
                    },
                },
                notchedOutline: {
                    border: '1px solid',
                    borderColor: colores.principales.apoyo,
                    boxSizing: 'border-box',
                    borderRadius: '4px',
                    borderTopRightRadius: '0px',
                    borderBottomRightRadius: '0px'
                },
            },
            MuiInputLabel: {//Evita que se reduzca el título
                shrink: {
                    transform: 'none'
                },
            },
        },
    })
    return overInputs;
}